module.exports = __webpack_public_path__ + "static/media/heart_fill_icon1121bdc822c0fc88dce10ec0e557fc96.webp";